/**
 * Check if there is an account for the entered email address
 */
export function dyanne_platformAccountUserCheck() {
	const form = document.querySelector('.account-canvas form');

	if (!form) {
		return;
	}

	form.addEventListener('submit', function(e) {
		e.preventDefault();

		const formData = new FormData(form);

		formData.append('action', 'dyanne_platform_account_check_user');

		fetch(dyanne_platform_xhr.ajaxurl, {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
				if ( data.user_exists === true ) {
					window.dispatchEvent(new CustomEvent('toggle-account', {detail: 'hide' }));
					window.dispatchEvent(new CustomEvent('toggle-login', {
						detail: {
							action: 'show',
							email: formData.get('user_email'),
						}
					}));
				} else {
					window.dispatchEvent(new CustomEvent('toggle-account', {detail: 'hide' }));
					window.dispatchEvent(new CustomEvent('toggle-register', {
						detail: {
							action: 'show',
							email: formData.get('user_email'),
						}
					}));
				}
            })
            .catch((error) => {
            });
	});
}
